import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "../ui/label";

interface Props {
  setIsAm: React.Dispatch<React.SetStateAction<boolean>>;
  label: string;
}
function AmPmDropdown({ setIsAm, label }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Label>{label}</Label>
      <Select
        onValueChange={(value) => {
          setIsAm(value === "AM");
        }}
        defaultValue={"AM"}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {["AM", "PM"].map((time) => (
            <SelectItem key={time} value={time}>
              {time}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default AmPmDropdown;
